import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=5d1500ce&scoped=true"
import script from "./ReportDetails.vue?vue&type=script&lang=js"
export * from "./ReportDetails.vue?vue&type=script&lang=js"
import style0 from "./ReportDetails.vue?vue&type=style&index=0&id=5d1500ce&prod&lang=scss"
import style1 from "./ReportDetails.vue?vue&type=style&index=1&id=5d1500ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1500ce",
  null
  
)

export default component.exports